module.exports = __webpack_public_path__ + "static/media/MHSB168.1d936b5b.png";